import { cva } from 'class-variance-authority'

import { getTokenImage } from '@/ui/assets/tokens'
import { IconStack } from '@/ui/molecules/icon-stack/IconStack'
import { cn } from '@/ui/utils/style'

import { EModeCategory } from '../types'

interface EModeCategoryTileProps {
  eModeCategory: EModeCategory
}

export function EModeCategoryTile({ eModeCategory }: EModeCategoryTileProps) {
  if (eModeCategory.tokens.length === 0) {
    return null
  }

  const iconPaths = eModeCategory.tokens.map(({ symbol }) => getTokenImage(symbol))
  const variant = eModeCategory.isActive ? 'active' : 'inactive'

  return (
    <button
      onClick={eModeCategory.onSelect}
      className={cn(
        'flex w-full flex-col items-start border-border text-start',
        'h-28 justify-between rounded-xl border bg-panel p-2 sm:h-32 sm:p-4',
        'transition-colors duration-200 hover:bg-muted hover:shadow-sm',
        eModeCategory.isSelected && 'border-primary',
      )}
    >
      <h4 className={headerVariants({ variant })}>{eModeCategory.name}</h4>
      <IconStack paths={iconPaths} maxIcons={4} />
      <ActivityBadge variant={variant} />
    </button>
  )
}

function ActivityBadge({ variant }: { variant: 'active' | 'inactive' }) {
  return <div className={activityBadgeVariants({ variant })}>{variant === 'active' ? 'Active' : 'Inactive'}</div>
}

const activityBadgeVariants = cva('rounded-lg px-2.5 py-1.5 font-semibold text-xs leading-none tracking-wide', {
  variants: {
    variant: {
      inactive: 'bg-accent text-muted-foreground',
      active: 'bg-primary/10 text-primary',
    },
  },
})

const headerVariants = cva('font-semibold text-xs sm:text-base', {
  variants: {
    variant: {
      active: 'text-foreground',
      inactive: 'text-muted-foreground',
    },
  },
})
